import React from "react";
import { useSelector } from "react-redux";
import jwtEncode from "jwt-encode";
import { NavigatorIcon } from "../../Assets/Icons";
import { applicationId, defaultLogo } from "../../env";

const AppNavigator = () => {
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const applications = useSelector((state) => state.applicationSlice).apps;

  const redirectApplication = (link) => {
    if (userData?.token && link) {
      const payload = { token: userData?.token };
      const token = jwtEncode(payload, "");

      if (link.includes("apps.simulanis.io")) {
        const newUrl = `${link}`;
        window.location.href = newUrl;
      } else {
        const newUrl = `${link}?referrer=${token}`;
        window.location.href = newUrl;
      }
    }
  };

  return (
    <>
      <div className="dropdown navigator">
        <div className="profile-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
          <NavigatorIcon />
        </div>
        <div className="dropdown-menu">
          <div className="menu-long">
            <div className={applications.length > 2 ? "menubg extraspace" : "menubg"}>
              {applications.map((e, index) => {
                if (e.uuid === applicationId) return null;
                return (
                  <div
                    onClick={() => redirectApplication(e.channel?.origins[0]?.url)}
                    key={e.uuid}
                    className="appshere"
                  >
                    <img
                      src={e.icon || configData.config.defaultLogo}
                      onError={(e) => {
                        e.target.src = `${configData.config.defaultLogo}`;
                        e.onerror = null;
                      }}
                      alt=""
                      referrerPolicy={"no-referrer"}
                    />
                    <p>{e.name}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppNavigator;
